import { WidgetStatePublisher as BasePublisher } from '../../shared/WidgetStatePublisher';
import type { VideoBroadcastStateParams } from '../types';

export class VideoBroadcastStatePublisher extends BasePublisher<VideoBroadcastStateParams> {}
